import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'mmb-web-app-add-primary-industries-modal',
  templateUrl: './add-primary-industries-modal.component.html',
  styleUrls: ['./add-primary-industries-modal.component.scss']
})
export class AddPrimaryIndustriesModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({});
  }

  onClose() {
    this.closed.emit();
  }

}
